<nav
  malihu-scrollbar
  [ngClass]="{ active: sideOpen, 'md:hidden': !surveyPage }"
  class="absolute z-50 h-[calc(100vh-57px)] min-w-[18rem] overflow-y-auto border-r border-zinc-900/15 bg-white p-4 md:relative md:h-full dark:border-white/10 dark:bg-zinc-900"
>
  <!-- mobile navbar -->
  <div class="pb-4 md:hidden">
    <h4 class="text pb-2 text-zinc-900 dark:text-zinc-200">Navigate Page</h4>
    <div class="flex flex-col ps-4">
      <a *ngFor="let page of pageNav" [routerLink]="page.route">
        {{ page.name }}
      </a>
    </div>
  </div>

  <!-- side bar -->
  <div *ngIf="surveyPage">
    <h4 class="text pb-2 text-zinc-900 dark:text-zinc-200">Navigate Survey</h4>
    <div class="px-4">
      <ul
        class="flex flex-col gap-1.5 border-l border-zinc-900/15 dark:border-white/10"
      >
        <li
          *ngFor="let dropdown of questionDropwdown"
          routerLinkActive="active"
          class="flex items-center"
        >
          <div *ngIf="dropdown.Completed">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              class="mx-2 size-5 stroke-cam-green"
            >
              <path
                fill-rule="evenodd"
                d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <div *ngIf="!dropdown.Completed">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              class="mx-2 size-5 fill-cam-orange"
            >
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8-5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 10 5Zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <a routerLink="{{ dropdown.Route }}">{{ dropdown.Name }}</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
